import api from '@/services/Http'

// GET /sync/settings (plano híbrido D-H13, F2) — flags de fluxo resolvidas
// do tenant: { legacyImportEnabled, v2ImportEnabled }
export const getSyncSettings = async () => (await api()).get('/sync/settings')
